// Shablon: 1 dan N gacha bo'sh `=== N ===` markerlar, har birining ostida bitta bo'sh qator. UTF-8.

export function buildTemplate(pageCount) {
    const count = Math.max(0, Math.floor(Number(pageCount) || 0));
    return Array.from({ length: count }, (_, index) => `=== ${index + 1} ===\r\n\r\n`).join('');
}

// spiker-matnlari-<PDF nomi>.txt — Windows fayl nomida ishlamaydigan belgilar "_" ga almashtiriladi
export function templateFileName(pdfName) {
    const base = String(pdfName || '')
        .replace(/\.pdf$/i, '')
        .replace(/[\\/:*?"<>|]/g, '_')
        .trim();
    return `spiker-matnlari-${base || 'pdf'}.txt`;
}

export function downloadTemplate(pageCount, pdfName) {
    const blob = new Blob([buildTemplate(pageCount)], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = templateFileName(pdfName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}
